"use client";

import { createContext, type RefObject, useContext } from "react";

export type SidekickPanelContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
  /**
   * Opens the panel on a new conversation and sends the message. Resolves when
   * the turn ends; `accepted` is false when the Sidekick refused the message,
   * such as on an exhausted trial allowance, while it was answering another
   * one, or when the panel was not ready. A refused message keeps the current
   * conversation. `pageUrl` replaces the current page as the message context.
   */
  startConversationWith: (
    message: string,
    options?: { pageUrl?: string | null }
  ) => Promise<{ accepted: boolean }>;
  toggleOpen: () => void;
  triggerRef: RefObject<HTMLButtonElement | null>;
};

export const SidekickPanelContext =
  createContext<SidekickPanelContextValue | null>(null);

/**
 * The panel outside the Sidekick bundle. Null while the lazy provider loads
 * and when the assistant is not enabled.
 */
export function useOptionalSidekickPanel(): SidekickPanelContextValue | null {
  return useContext(SidekickPanelContext);
}

export type SidekickConversationStarter = Pick<
  SidekickPanelContextValue,
  "startConversationWith"
>;
